import(/* webpackMode: "eager" */ "/vercel/path0/apps/alhome/src/app/global-error.jsx");
